import { Form, Grid, Icon, Table } from 'semantic-ui-react';
import styled from 'styled-components'

export const StyledHeader = styled.div`
 margin-bottom: 15px;
 display: flex;
 align-items: center;
 .header {
    font-size: 16px !important;
    font-weight: bold;
    margin-right: 10px;
 }
`
export const StyledErrorLabel = styled.div`
white-space: normal;
background: #fff !important;
border: 1px solid #e0b4b4 !important;
color: #9f3a38 !important;
`
export const DrawerFooter = styled(Form.Field)`
margin: 3rem 0 !important;
display: flex;
gap: 10px;
justify-content: flex-end;
`;

export const CellWrapper = styled.div`
font-weight: bold !important;
`
export const ColumnLabels = styled(Grid.Column)`
width: 40% !important;
`
export const ExpandableRow = styled(Table.Row)`
  cursor: pointer;
  &:hover {
    background-color: #f9f9f9 !important;
  }
`

export const ExpandedCell = styled(Table.Cell) <{ $isOpen: boolean }>`
  padding: 0 !important;
  ${({ $isOpen }) => !$isOpen && 'border-top: none !important;'}
`

export const ExpandedContent = styled.div<{ $isOpen: boolean }>`
  overflow: hidden;
  max-height: ${({ $isOpen }) => ($isOpen ? '800px' : '0')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  transition: max-height 0.35s ease, opacity 0.25s ease;
  background-color: #f8f9fa;
`

export const ExpandedInner = styled.div`
  padding: 16px 24px;
`

export const ChevronIcon = styled(Icon) <{ $isOpen: boolean }>`
  transition: transform 0.3s ease !important;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(90deg)' : 'rotate(0deg)')} !important;
`

export const HeaderDialog = styled.div`
font-size: 18px !important;
`